import React from 'react';
import { Link } from 'react-router-dom';
import { Plane as Plant } from 'lucide-react';
import type { BlogPost } from '../../types/blog';

interface RelatedPlantsProps {
  plants: NonNullable<BlogPost['plants']>;
}

export default function RelatedPlants({ plants }: RelatedPlantsProps) {
  if (!plants.length) return null;

  return (
    <div className="bg-white rounded-lg shadow-sm p-6 mb-8">
      <div className="flex items-center gap-2 mb-4">
        <Plant className="h-5 w-5 text-primary-500" />
        <h3 className="font-semibold">Featured Plants</h3>
      </div>
      
      <div className="space-y-4">
        {plants.map((plant) => (
          <Link
            key={plant.id}
            to={`/plants/${plant.id}`}
            className="flex items-center gap-3 p-3 rounded-lg border hover:border-primary-200 hover:bg-primary-50 transition-colors"
          >
            <img
              src={plant.image_url}
              alt={plant.name}
              className="w-12 h-12 rounded-lg object-cover"
            />
            <div>
              <h4 className="font-medium">{plant.name}</h4>
              <p className="text-sm text-gray-500 italic">{plant.scientific_name}</p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}